import type { ILockBtnProps } from '../WithLock/LockBtn';
import { LockBtn } from '../WithLock/LockBtn';
import type { INewAmountInputProps } from './NewAmountInput';
import { NewAmountInput } from './NewAmountInput';

export type AmountInputWithLockProps = INewAmountInputProps & ILockBtnProps;
export const AmountInputWithLock = (props: AmountInputWithLockProps) => {
  const { isLocked, isDisabled, isLoading, onLockChanged, tabIndex, isDelegated, ...amountProps } = props;

  return (
    <NewAmountInput
      {...amountProps}
      isDisabled={isLocked || isDisabled || isLoading}
      tabIndex={tabIndex ? tabIndex + 1 : undefined}
      prepend={
        <LockBtn
          isDelegated={isDelegated}
          e2e={props.e2e}
          isLocked={isLocked}
          onLockChanged={onLockChanged}
          isDisabled={isDisabled}
          isLoading={isLoading}
          tabIndex={tabIndex}
        />
      }
    />
  );
};
AmountInputWithLock.displayName = 'AmountInputWithLock';
